/*
  In-grid promo tiles (MSK-79): desktop 2x2 tiles must end on the image line of the
  product cards in their second row. Rows can differ in height (swatches, badges,
  quick-buy), so the CSS estimate (50% + gap) is replaced with a measurement of the
  neighbouring card. 1x1 / 2x1 / 4x1 are exact in CSS and are left alone.
*/
(function () {
  const GRID_SELECTOR = '#product-grid.product-grid--spans';
  const DESKTOP = window.matchMedia('(min-width: 990px)');

  function fitTile(tile) {
    const inner = tile.querySelector('.grid__promo__inner');
    if (!inner) return;

    if (!DESKTOP.matches || !tile.classList.contains('grid__promo--2x2')) {
      inner.style.height = '';
      inner.style.paddingBottom = '';
      return;
    }

    // Row positions come from offsetTop, which ignores transforms: cards appended by
    // load more are still mid slide-in (translateY) when this runs, and their
    // bounding rects would put row-one cards inside the tile's second row.
    const grid = tile.parentElement;
    const tileTop = tile.offsetTop;
    const tileBottom = tileTop + tile.offsetHeight;
    let rowTwoNeighbour = null;
    for (const item of grid.children) {
      if (item === tile || item.classList.contains('grid__promo')) continue;
      const top = item.offsetTop;
      if (top > tileTop + 1 && top < tileBottom - 1) {
        rowTwoNeighbour = item;
        break;
      }
    }
    if (!rowTwoNeighbour) {
      inner.style.height = '';
      inner.style.paddingBottom = '';
      return;
    }

    const media = rowTwoNeighbour.querySelector('.card__inner') || rowTwoNeighbour;
    const height =
      rowTwoNeighbour.offsetTop -
      tileTop +
      (media.getBoundingClientRect().bottom - rowTwoNeighbour.getBoundingClientRect().top);
    inner.style.height = `${height}px`;
    inner.style.paddingBottom = '0';
  }

  function fitAll(grid) {
    grid.querySelectorAll(':scope > .grid__promo').forEach(fitTile);
  }

  function init() {
    const grid = document.querySelector(GRID_SELECTOR);
    if (!grid) return;

    let frame = 0;
    const schedule = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => fitAll(grid));
    };

    schedule();
    new ResizeObserver(schedule).observe(grid);
    new MutationObserver(schedule).observe(grid, { childList: true });
    DESKTOP.addEventListener('change', schedule);
    window.addEventListener('load', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
